import { render, staticRenderFns } from "./search.vue?vue&type=template&id=387d51cf&scoped=true&"
import script from "./search.vue?vue&type=script&lang=js&"
export * from "./search.vue?vue&type=script&lang=js&"
import style0 from "./search.vue?vue&type=style&index=0&id=387d51cf&prod&scoped=true&lang=less&"
import style1 from "./search.vue?vue&type=style&index=1&id=387d51cf&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../../../../yiweb/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "387d51cf",
  null
  
)

export default component.exports